module.exports = __webpack_public_path__ + "img/slider1.0f583e54.jpg";